import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "20",
  fill: "none",
  viewBox: "0 0 12 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.309 4.154q0-.021-.002-.043A4.155 4.155 0 0 0 0 4.154v9.99a5.856 5.856 0 1 0 11.712 0V7.558a.75.75 0 0 0-1.5 0v6.586a4.357 4.357 0 0 1-8.712 0v-9.99a2.654 2.654 0 1 1 5.308 0v9.99a.952.952 0 0 1-1.904 0v-9.99a.75.75 0 1 0-1.5 0v9.99a2.452 2.452 0 0 0 4.905 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }